<template>
  <div class>
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <!--Viewing-->
            <div class="AssetViewing" v-show="!isEditing">
              <div class="form-group col-md-5">
                <p style="font-size:35px">{{asset["BsNzKuUbOpA9duKR4mUg"]}}</p>
                <div v-for="dataField in dataFields">
                  <p v-if="dataField.type === 'selector'" style="font-size:15px">{{dataField.name}}: {{Object.values(asset[dataField['.key']]).join(", ")}}</p>
                  <p v-else-if="dataField.type === 'timestamp'" style="font-size:15px">{{dataField.name}}: {{unix_to_norm(new Date((asset[dataField['.key']].seconds) * 1000))}}</p>
                  <p v-else style="font-size:15px">{{dataField.name}}: {{asset[dataField['.key']]}}</p>
                </div>
                <br />
                <button v-on:click="edit" type="button" class="btn btn-default form-group">Edit</button>
              </div>
            </div>
            <!--Editing-->
            <div class="AssetEditing col-md-5" v-show="isEditing">
              <form-text
                ref="assetname"
                styler="font-size:35px"
                label="Asset Name"
                name="assetname"
                v-model="assetEdit.name"
                validation="required"
              ></form-text>
              <br />
              <div class="form-group">
                <button v-on:click="cancelEdit" type="button" class="btn btn-default">Cancel</button>
                <button v-on:click="submitEdit" type="button" class="btn btn-success">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
import VueMask from "v-mask";
import VueFire from "vuefire";
import FormText from "../../elements/Form/FormText";
import FormTextMask from "../../elements/Form/FormTextMask";
import FormTextArea from "../../elements/Form/FormTextArea";
import database from "../../webmaster/Database/database";

import store from "../../../components/webmaster/Store/vuex";

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: "assetdetail",
  components: {
    "form-text": FormText,
    "form-textarea": FormTextArea
  },
  data() {
    return {
      asset: "",
      assetEdit: "",
      isEditing: false,
      dataFields: []
    };
  },
  firestore() {
    let orgId = this.$store.state.usermain.curOrg.id;
    let assetId = this.$route.params.id;

    return {
      asset: database.getFireStoreDoc(
        "orgs/" + orgId + "/assets/" + assetId + "/data/fields"
      )
    };
  },
  created: function() {
    this.fetchAsset();
    this.fetchDataFields();
  },
  methods: {
    unix_to_norm: function(pubDate){
      const weekday = new Array("Sun","Mon","Tue","Wed","Thu","Fri","Sat");
      const monthname = new Array("Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec");

      var hours = pubDate.getHours();
      var minutes = pubDate.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var time = hours + ':' + minutes + ' ' + ampm;
      return weekday[pubDate.getDay()] + ' ' 
                + monthname[pubDate.getMonth()] + ' ' 
                + pubDate.getDate() + ', ' 
                + pubDate.getFullYear() + ' at ' 
                + time
    },
    edit: function() {
      this.isEditing = true;
    },
    cancelEdit: function() {
      this.isEditing = false;
    },
    submitEdit: function() {},
    fetchAsset: function() {
      this.asset = {"6orf3N149UPSpJDrPXDs":{"ALtxBrGX77YoICHKa1Yq":"Tools"},"BsNzKuUbOpA9duKR4mUg":"3/32-Inch Drill Bits","HuvK5wgv0IXQjusf2rm3":{"seconds":1588309200,"nanoseconds":0},"QH6UO0GcI5H3qxdHLels":47,"ViB5zETGIqN2nt2sU5um":"B-15","b0H0OnCNXelSP4zlSGps":"Be careful where these are kept","lRljdNGrOxmYT84vLn46":"Drilling","qfwqOu9HWPeXWudgBIia":{"seconds":1575180000,"nanoseconds":0},"rcgd6ZrS3yWlkdo4wrd6":"8","y7vtrGO3xxiiunUGXAgF":{"wx3JKE9m7hSnhHbYA0HW":"Class 3"}};
      this.assetEdit = this.asset;
      /*let orgId = this.$store.state.usermain.curOrg.id;
      let assetId = this.$route.params.id;

      let self = this;

      let doc = database.getFireStoreDoc(
        "orgs/" + orgId + "/assets/" + assetId + "/data/fields"
      );

      doc.get().then(function(doc) {
        if (doc.exists) {
          self.assetEdit = doc.data();
          self.asset = doc.data();
        } else {
          // doc.data() will be undefined in this case
          console.log(
            "No such document at " +
              "orgs/" +
              orgId +
              "/assets/" +
              assetId +
              "/data/fields"
          );
        }
      });*/
    },
    fetchDataFields: function() {
      let _dateFields = {"6orf3N149UPSpJDrPXDs":{"name":"Groups","options":{"0LHSU9UmnqsPXzQ5vT5w":"Medicine","ALtxBrGX77YoICHKa1Yq":"Tools","KKqkAOzzxvgbk49ljtmh":"Entertainment","WfK3QL2TVz5qImDX3eR2":"Book","oyDvLSAce4mAgA2g5vYr":"Pain Reliever","spV4liYK2Ib6n1MI5KUZ":"Bedding"},"type":"selector",".key":"6orf3N149UPSpJDrPXDs"},"HuvK5wgv0IXQjusf2rm3":{"name":"Retire Date","type":"timestamp",".key":"HuvK5wgv0IXQjusf2rm3"},"QH6UO0GcI5H3qxdHLels":{"name":"Quantity","type":"number",".key":"QH6UO0GcI5H3qxdHLels"},"ViB5zETGIqN2nt2sU5um":{"name":"Location","type":"text",".key":"ViB5zETGIqN2nt2sU5um"},"b0H0OnCNXelSP4zlSGps":{"name":"Notes","type":"text",".key":"b0H0OnCNXelSP4zlSGps"},"lRljdNGrOxmYT84vLn46":{"name":"Usage","type":"text",".key":"lRljdNGrOxmYT84vLn46"},"qfwqOu9HWPeXWudgBIia":{"name":"Mainenance Date","type":"timestamp",".key":"qfwqOu9HWPeXWudgBIia"},"rcgd6ZrS3yWlkdo4wrd6":{"name":"Checked Out Quantity","type":"number",".key":"rcgd6ZrS3yWlkdo4wrd6"},"y7vtrGO3xxiiunUGXAgF":{"name":"Tool Class","options":{"UZRdF2EMvfJ4KWwH4PvQ":"Class 1","wTX1jKSKMZXfPJrKE8vf":"Class 2","wx3JKE9m7hSnhHbYA0HW":"Class 3"},"type":"selector",".key":"y7vtrGO3xxiiunUGXAgF"}};

      this.dataFields = _dateFields;

      /*let orgId = this.$store.state.usermain.curOrg.id;

      let self = this;
      
      let collection = database.getFireStoreColl(
        "orgs/" + orgId + "/datafields/"
      );

      collection.get().then(function(querySnapshot) {
        let _dateFields = {};

        querySnapshot.forEach(doc => {
          if (self.asset[doc.id] != null && doc.id != "BsNzKuUbOpA9duKR4mUg") {
            let docData = doc.data()

            docData['.key'] = doc.id

            console.log(docData);

            _dateFields[doc.id] = docData;
          }
        });

        self.dataFields = _dateFields;
      });*/
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// AssetDetail.vue?7600d6a6